import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3cd5fd84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container w-75" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = {
  key: 0,
  class: "form-container"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = { key: 4 }
const _hoisted_9 = { key: 5 }
const _hoisted_10 = { key: 6 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DetailsHeader = _resolveComponent("DetailsHeader")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Table = _resolveComponent("Table")!
  const _component_DetailsRow = _resolveComponent("DetailsRow")!
  const _component_PersonDetails = _resolveComponent("PersonDetails")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DetailsHeader, {
      title: _ctx.$t('shared.routes.note-taker-details'),
      onBack: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigateToOverview())),
      onPrevious: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigateToNoteTaker(_ctx.previousNoteTakerId))),
      onNext: _cache[2] || (_cache[2] = ($event: any) => (_ctx.navigateToNoteTaker(_ctx.nextNoteTakerId)))
    }, null, 8, ["title"]),
    _createElementVNode("form", _hoisted_2, [
      (_ctx.noteTaker !== null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_PersonDetails, { person: _ctx.noteTaker }, {
              default: _withCtx(() => [
                _createVNode(_component_DetailsRow, { caption: "shared.courses" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Table, {
                      rows: _ctx.supportCourseRows,
                      hiddenColumns: _ctx.hiddenSupportCourseColumns,
                      sortColumn: _ctx.sortColumn,
                      "onUpdate:sortColumn": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.sortColumn) = $event)),
                      ascending: _ctx.ascending,
                      "onUpdate:ascending": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.ascending) = $event)),
                      onSortChanged: _ctx.onSortChange
                    }, {
                      td: _withCtx((data) => [
                        (data.col === 'status')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t("course-occurrence.status")), 1))
                          : (data.col === 'occurrence')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t("course-occurrence.occurrence")), 1))
                            : (data.col === 'courseOccurrenceStart')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t("course-occurrence.courseStartDate")) + " " + _toDisplayString(_ctx.$t("course-occurrence.abbreviation")), 1))
                              : (data.col === 'offerDate')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t("shared.offer")) + " " + _toDisplayString(_ctx.$t("note-taker-details.note-taker-abbreviation")), 1))
                                : (data.col === 'assignmentStart')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t("course-occurrence.assignment.assignment-start")), 1))
                                  : (data.col === 'assignmentEnd')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t("course-occurrence.assignment.assignment-end")), 1))
                                    : (data.col === 'coordinatorName')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.$t("shared.coordinator")) + " " + _toDisplayString(_ctx.$t("course-occurrence.abbreviation")), 1))
                                      : _createCommentVNode("", true)
                      ]),
                      default: _withCtx((data) => [
                        (data.col === 'status')
                          ? (_openBlock(), _createBlock(_component_Tooltip, {
                              key: 0,
                              text: _ctx.statusText(data.val),
                              bgColor: _ctx.statusBgColor(data.val),
                              color: _ctx.statusTextColor(data.val)
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Badge, {
                                  rounded: true,
                                  backgroundColor: _ctx.statusBgColor(data.val)
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_11
                                  ]),
                                  _: 2
                                }, 1032, ["backgroundColor"])
                              ]),
                              _: 2
                            }, 1032, ["text", "bgColor", "color"]))
                          : _createCommentVNode("", true),
                        (data.col === 'occurrence')
                          ? (_openBlock(), _createBlock(_component_Tooltip, {
                              key: 1,
                              text: _ctx.getCourseTitle(data.row.titleSv, data.row.titleEn),
                              bgColor: _ctx.tooltipBgColor
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_router_link, {
                                  to: {
                      name: 'CourseOccurrenceDetails',
                      params: {
                        id: data.row.courseOccurrenceId,
                      },
                    }
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.replaceUnvailableOrFormatDate(data.val)), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]),
                              _: 2
                            }, 1032, ["text", "bgColor"]))
                          : _createCommentVNode("", true),
                        (
                    (data.col === 'courseOccurrenceStart' ||
                      data.col === 'offerDate' ||
                      data.col === 'assignmentStart' ||
                      data.col === 'assignmentEnd') &&
                    data.val
                  )
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.replaceUnvailableOrFormatDate(data.val)), 1))
                          : _createCommentVNode("", true),
                        (data.col === 'coordinatorName')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(data.val), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["rows", "hiddenColumns", "sortColumn", "ascending", "onSortChanged"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["person"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}